export function useUtils() {
  const isValidDateBR = (date) => {
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(date)) return false

    const [day, month, year] = date.split('/').map(Number)

    const parsedDate = new Date(year, month - 1, day)
    return parsedDate.getFullYear() === year && parsedDate.getMonth() === month - 1 && parsedDate.getDate() === day
  }

  const applyMask = (value, mask) => {
    if (!mask || !value) return value

    const cleanValue = value.toString().replace(/\D/g, '')
    let maskedValue = ''
    let cleanIndex = 0

    for (let i = 0; i < mask.length; i++) {
      if (cleanIndex >= cleanValue.length) break

      if (mask[i] === '#') {
        maskedValue += cleanValue[cleanIndex++]
      } else {
        maskedValue += mask[i]
      }
    }

    return maskedValue
  }

  const applyLicensePlateMask = (value) => {
    if (!value) return value
    const cleanValue = value
      .toString()
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
    const limited = cleanValue.substring(0, 7)
    if (limited.length <= 3) {
      return limited
    } else {
      return limited.substring(0, 3) + '-' + limited.substring(3)
    }
  }

  const getFieldsFromArray = (header) => {
    let headerFields = []
    for (const item of header) {
      headerFields.push(item.field)
    }
    return headerFields
  }

  const orderArray = (order, items) => {
    const { column, direction } = order

    items.sort((a, b) => {
      const valueA = a[column]
      const valueB = b[column]

      if (valueA === undefined || valueA === null) return 1
      if (valueB === undefined || valueB === null) return -1

      if (!isNaN(valueA) && !isNaN(valueB)) {
        return direction === 'asc' ? valueA - valueB : valueB - valueA
      }

      return direction === 'asc' ? String(valueA).localeCompare(String(valueB)) : String(valueB).localeCompare(String(valueA))
    })
  }

  return {
    applyMask,
    applyLicensePlateMask,
    isValidDateBR,
    getFieldsFromArray,
    orderArray,
  }
}
